var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9809 27.1426C95.5269 15.8862 81.8066 9.1391 70.1881 13.6054C56.9252 18.7041 61.3204 39.6576 49.2753 43.8937C42.766 46.1837 33.1472 37.6316 26.5699 36.3209C14.4537 33.9051 3.48426 42.3958 0.782853 54.1525C-1.97419 66.1488 2.44574 82.1693 15.7179 85.4262C31.5245 89.3032 39.7586 75.192 53.0214 71.14C66.6305 66.9806 81.7602 76.8035 93.0264 64.8534C101.35 56.025 104.392 38.2886 99.9839 27.1426H99.9809Z",
    fill: "url(#paint0_linear_4432_38356)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9022 28.802C89.6487 28.802 89.3922 28.7066 89.1974 28.5127L88.0105 27.3306L86.8236 28.5127C86.4342 28.9005 85.8036 28.9005 85.4142 28.5127C85.0247 28.1248 85.0247 27.4968 85.4142 27.1089L87.3058 25.225C87.6953 24.8371 88.3258 24.8371 88.7152 25.225L90.6069 27.1089C90.9963 27.4968 90.9963 28.1248 90.6069 28.5127C90.4122 28.7066 90.1587 28.802 89.9022 28.802Z",
    fill: "#FF6679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7518 8.20955C28.4983 8.20955 28.2418 8.30498 28.047 8.49891L26.8601 9.681L25.6732 8.49891C25.2838 8.11104 24.6532 8.11104 24.2638 8.49891C23.8743 8.88678 23.8743 9.51477 24.2638 9.90264L26.1554 11.7866C26.5449 12.1745 27.1754 12.1745 27.5649 11.7866L29.4565 9.90264C29.846 9.51477 29.846 8.88678 29.4565 8.49891C29.2618 8.30805 29.0052 8.20955 28.7518 8.20955Z",
    fill: "#1CCDE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8732 94.18C69.1345 94.18 68.3927 93.8999 67.8301 93.3397C66.7051 92.2191 66.7051 90.3937 67.8301 89.2701C68.9552 88.1496 70.7881 88.1496 71.9163 89.2701C73.0414 90.3906 73.0414 92.2161 71.9163 93.3397C71.3538 93.8999 70.612 94.18 69.8732 94.18ZM69.8701 90.4121C69.6414 90.4121 69.4096 90.4983 69.2365 90.6738C68.8872 91.0217 68.8872 91.5881 69.2365 91.9359C69.5858 92.2838 70.1545 92.2838 70.5038 91.9359C70.8531 91.5881 70.8531 91.0217 70.5038 90.6738C70.3307 90.4983 70.0989 90.4121 69.8701 90.4121Z",
    fill: "#CC9AC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2258 21.4476C20.487 21.4476 19.7452 21.1675 19.1827 20.6072C18.0576 19.4867 18.0576 17.6613 19.1827 16.5377C20.3078 15.4171 22.1407 15.4171 23.2689 16.5377C24.394 17.6582 24.394 19.4836 23.2689 20.6072C22.7063 21.1675 21.9645 21.4476 21.2258 21.4476ZM21.2227 17.6797C20.994 17.6797 20.7621 17.7659 20.589 17.9414C20.2398 18.2892 20.2398 18.8557 20.589 19.2035C20.9383 19.5514 21.507 19.5514 21.8563 19.2035C22.2056 18.8557 22.2056 18.2892 21.8563 17.9414C21.6832 17.7659 21.4514 17.6797 21.2227 17.6797Z",
    fill: "#CC9AC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5344 77.2152C9.79564 77.2152 9.05382 76.9351 8.49128 76.3748C7.36619 75.2543 7.36619 73.4288 8.49128 72.3052C9.61637 71.1847 11.4493 71.1847 12.5775 72.3052C13.7026 73.4258 13.7026 75.2512 12.5775 76.3748C12.0149 76.9351 11.2762 77.2152 10.5344 77.2152ZM10.5344 73.4473C10.3056 73.4473 10.0738 73.5335 9.90073 73.709C9.55146 74.0568 9.55146 74.6232 9.90073 74.9711C10.25 75.3189 10.8187 75.3189 11.168 74.9711C11.5173 74.6232 11.5173 74.0568 11.168 73.709C10.9918 73.5335 10.7631 73.4473 10.5344 73.4473Z",
    fill: "#1CCDE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.353 25.75C62.3498 11.8037 39.6502 11.8037 25.647 25.75C11.6439 39.6963 11.6439 62.3037 25.647 76.25C39.6502 90.1963 62.3498 90.1963 76.353 76.25",
    stroke: "#0056CC",
    strokeWidth: 2.65775,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3525 76.25C90.3557 62.3037 90.3557 39.6963 76.3525 25.75",
    stroke: "#0056CC",
    strokeWidth: 2.65775,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "9.97 7.97"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4432_38356",
    x1: 102,
    y1: 49.1531,
    x2: 0,
    y2: 49.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF3FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressImage);
export default __webpack_public_path__ + "static/media/progress-image.c66196ab2cfc8efdb552d7dc5a389b3b.svg";
export { ForwardRef as ReactComponent };